export default __webpack_public_path__ + "static/tiktok-944f64cffa5141970ce13168d46eacbc.svg";